import { AuthContext } from "auth"
import { useContext } from "react"
import {Navigate } from "react-router-dom";

export const PublicRoute=({children}) =>{
    const {logged}=useContext(AuthContext)
    //console.warn(logged)
    const ruta=localStorage.getItem('lastPath') || '/admin';
    
    return (!logged) ? children: <Navigate to={ruta} />
}